import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import api, { API_BASE } from '../api';
import { isSpecialAvatarUser, SpecialAvatar } from './UserBadge';
import { trackEvent } from '../analytics';

function avatarColor(username) {
  var hash = 0;
  for (var i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash);
  }
  var hue = ((hash % 360) + 360) % 360;
  return 'hsl(' + hue + ', 55%, 55%)';
}

var SuggestionsSection = styled.div`
  width: 100%;
  max-width: 400px;
`;

var SuggestionsTitle = styled.div`
  font-weight: 700;
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 0.5em;
`;

var CarouselScroll = styled.div`
  display: flex;
  gap: 0.75em;
  overflow-x: auto;
  padding-bottom: 0.5em;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

var SuggestionCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 120px;
  min-width: 120px;
  padding: 0.75em 0.5em;
  border: 1px solid #eee;
  border-radius: 12px;
  background: white;
`;

var SuggestionLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: inherit;
`;

var SuggestionAvatar = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
`;

var SuggestionAvatarPlaceholder = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.3em;
  font-weight: 700;
`;

var SuggestionName = styled.div`
  font-weight: 600;
  font-size: 0.8rem;
  margin-top: 0.4em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
`;

var SuggestionUsername = styled.div`
  color: #999;
  font-size: 0.65rem;
  margin-top: 0.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
`;

var MutualText = styled.div`
  color: #999;
  font-size: 0.65rem;
  margin-top: 0.15em;
`;

var FollowButton = styled.button`
  background: white;
  color: black;
  border: 1px solid black;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 8px;
  padding: 0.3em 0.75em;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: 0.5em;
  font-family: inherit;

  &:hover {
    background: #f0f0f0;
  }
`;

function SuggestedFriends(props) {
  var onFollow = props.onFollow;
  var _suggestions = useState([]);
  var suggestions = _suggestions[0];
  var setSuggestions = _suggestions[1];

  var _loaded = useState(false);
  var loaded = _loaded[0];
  var setLoaded = _loaded[1];

  useEffect(function () {
    api
      .get('/api/follows/suggestions')
      .then(function (res) {
        setSuggestions(res.data || []);
        setLoaded(true);
      })
      .catch(function () {
        setLoaded(true);
      });
  }, []);

  function handleFollow(userID) {
    var user = suggestions.find(function (s) {
      return s.id === userID;
    });
    trackEvent('follow_completed', {
      source: 'suggested_friends',
      target_user: user ? user.username : userID,
    });
    api
      .post('/api/follows/' + userID)
      .then(function () {
        setSuggestions(function (prev) {
          return prev.filter(function (s) {
            return s.id !== userID;
          });
        });
        if (onFollow) onFollow(userID);
      })
      .catch(function () {});
  }

  if (!loaded || suggestions.length === 0) return null;

  return (
    <SuggestionsSection>
      <SuggestionsTitle>Suggested for you</SuggestionsTitle>
      <CarouselScroll>
        {suggestions.map(function (s) {
          return (
            <SuggestionCard key={s.id}>
              <SuggestionLink to={'/profile/' + s.username}>
                {isSpecialAvatarUser(s.username) ? (
                  <SpecialAvatar size={52} />
                ) : s.profilePictureURL ? (
                  <SuggestionAvatar src={API_BASE + s.profilePictureURL} alt={s.username} />
                ) : (
                  <SuggestionAvatarPlaceholder style={{ background: avatarColor(s.username) }}>
                    {s.username.charAt(0).toUpperCase()}
                  </SuggestionAvatarPlaceholder>
                )}
                <SuggestionName>{s.displayName || s.username}</SuggestionName>
                <SuggestionUsername>@{s.username}</SuggestionUsername>
              </SuggestionLink>
              {s.mutualCount > 0 && (
                <MutualText>
                  {s.mutualCount} {s.mutualCount === 1 ? 'friend' : 'friends'} in common
                </MutualText>
              )}
              <FollowButton
                onClick={function () {
                  handleFollow(s.id);
                }}
              >
                Follow
              </FollowButton>
            </SuggestionCard>
          );
        })}
      </CarouselScroll>
    </SuggestionsSection>
  );
}

export default SuggestedFriends;
